const getAdhesionColor = (daiResponse, adhesionOptions, theme) => {
  const letter = daiResponse?.adhesion?.adhesionLetter
  if (!letter) return theme.palette.primary.main

  if (!adhesionOptions || adhesionOptions.length === 0)
    return theme.palette.primary.main

  const index = adhesionOptions.findIndex(
    (adhesionOption) => adhesionOption?.option === letter,
  )

  if (index === -1) return theme.palette.primary.main

  const total = adhesionOptions.length

  if (index === 0) return theme.palette.success.main
  if (index === total - 1) return theme.palette.error.main

  return theme.palette.warning.main
}

export default getAdhesionColor
